<div class="body">

    <div class="header" *ngIf="(issueAuditWrapperComponentService.issueAuditWrapper$|async).running">

        <mat-icon>lens</mat-icon>

    </div>

    <div class="content">

        <div class="headline">

            <div class="main-title">{{(issueAuditWrapperComponentService.issueAuditWrapper$|async)?.specialAction|auditSpecialAction}}</div>
            <div class="sub-title">durch {{(issueAuditWrapperComponentService.issueAuditWrapper$|async)?.userId|user|async}}, am {{(issueAuditWrapperComponentService.issueAuditWrapper$|async)?.recordEnd|date:'dd.MM.yyyy HH:mm'}}</div>
    
        </div>
    
        <app-issue-status-diff></app-issue-status-diff>
    
        <app-issue-transaction-audit></app-issue-transaction-audit>
    
        <app-issue-item-audit></app-issue-item-audit>
    
        <app-issue-user-assignment-audit></app-issue-user-assignment-audit>
    
        <app-issue-audit-email></app-issue-audit-email>
    
        <app-issue-audit-files></app-issue-audit-files>

    </div>

    <div class="footer" *ngIf="rightsMap.edit_datasets">

        <button mat-icon-button color="primary" (click)="markIssueAuditWrapperAsFinished()" *ngIf="isFirstEntry && ((issueAuditWrapperComponentService.issueAuditWrapper$|async)?.specialAction !== 3 || (issueAuditWrapperComponentService.issueAuditWrapper$|async)?.running)">
            <mat-icon>done</mat-icon>
        </button>

        <button mat-icon-button color="primary" (click)="markIssueAuditWrapperAsCreated()" *ngIf="isLastEntry && (issueAuditWrapperComponentService.issueAuditWrapper$|async)?.specialAction !== 1">
            <mat-icon>new_releases</mat-icon>
        </button>

        <button mat-icon-button color="warn" (click)="deleteIssueAuditWrapper()">
            <mat-icon>delete_forever</mat-icon>
        </button>

    </div>

</div>
